module.exports = __webpack_public_path__ + "img/credit.21c16b58.svg";